import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { DEFAULT_TIME } from "../../constants/input-entries-constants";
import { TalkhattabatConversationType } from "../../Types";

export const apiCallSendOneOOneMessage = async ({
  alkhattabaUUID,
  userUUID,
  alkhattabaText,
  userID,
  conversationType,
  isAiMessage
}: {
  alkhattabaUUID: string;
  userUUID: string;
  alkhattabaText: string;
  userID: number;
  conversationType: TalkhattabatConversationType;
  isAiMessage: boolean;
}): Promise<{
  data: { messageCurrentTime: string };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    messageCurrentTime: string;
  }>(`khattabat/sendOneOOneMsg`, {
    alkhattabaUUID,
    userUUID,
    userID,
    alkhattabaText,
    conversationType,
    isAiMessage
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: { messageCurrentTime: DEFAULT_TIME },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: { messageCurrentTime: DEFAULT_TIME },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
